import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import { FirebaseProvider } from "./contexts/FirebaseContext";
import { ModalProvider } from "./contexts/ModalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<FirebaseProvider>
			<ModalProvider>
				<App />
			</ModalProvider>
		</FirebaseProvider>
	</React.StrictMode>,
);
